import { project2BaseUrl } from './remoteClient'

export async function industriesRequest(token) {
    let res = await project2BaseUrl.get("/administration/getIndustries", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return res;
}